import { Component, inject, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { NgxSonnerToaster } from 'ngx-sonner';
import { ZardLoaderComponent } from '@shared/components/overlays/loader/loader.component';
import { Loader } from '@shared/services/loader/loader';
import { SocketService } from '@shared/services/socket/socket-service';
import { ChatbotService } from '@core/service/chatbot/chatbot.service';
import { ZardToastComponent } from "@shared/components/overlays/toast/toast.component";

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, ZardLoaderComponent, ZardToastComponent],
  templateUrl: './app.html'
})
export class App {
  protected readonly title = signal('Aalya.ai');
  protected readonly isLoading = inject(Loader).visible;
  private socketService = inject(SocketService);
  private chatbotService = inject(ChatbotService);
  // private session = inject(Session);


  ngOnInit(): void {
    // if(this.socketService.initialized) return
    this.socketService.init();
    this.chatbotService.init();
  }
}
